import React, { useEffect, useState } from 'react';
import { Grid, Button, Toolbar, Box, Typography, Divider, createTheme, darken } from '@mui/material';
import { PapiroConsole } from 'src/utils/papiroConsole';
import { useHistory } from "react-router-dom";
import Api from 'src/services/api';
import { styled, ThemeProvider } from '@mui/styles';

const Header = (props) => {

    const { intl, language, calledservicesettings, openCreateCalledDialog, logoimagesrc } = props

    const { title, enablecreatecalled, enablelogin, showknowledgebases, logoimage, defaultcolor, defaulttextcolor, enablefaq } = props.clientportal

    let history = useHistory()

    const gotToLogin = () => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"

        history.push(`/${language}`)
    }

    const gotToKnowledgeBases = () => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"

        history.push(`/${language}/knowledgebases-external`)
    }

    const gotToClientPortal = () => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"

        history.push(`/${language}/client-portal-external`)
    }

    const handleCreateCalled = () => {
        let frontCalledServiceUrl = Api.frontCalledServiceUrl()

        if (calledservicesettings.length == 1) {
            let route = `${frontCalledServiceUrl}${language}/${calledservicesettings[0].calledservicesettings.route}`
            window.open(`${route}`, '_blank')
        } else {
            const calledServiceSettingsList = calledservicesettings.map(item => {
                return {
                    id: item.calledservicesettings.id,
                    title: item.calledservicesettings.title,
                    OrganizationText: item.calledservicesettings.organization && item.calledservicesettings.organization.name ? item.calledservicesettings.organization.name : '',
                    RouteText: `${frontCalledServiceUrl}${language}/${item.calledservicesettings.route}`
                }
            })
            openCreateCalledDialog(calledServiceSettingsList)
        }
    }

    return (
        <Grid item xs={12} sm={12} width="100%" >
            <Toolbar>
                <Grid container spacing={1} alignItems="center" marginX="20vw" justifyContent="space-between" paddingY={1}>
                    <Grid container item sm={5} style={{ cursor: "pointer" }}>
                        <Grid item sm={6} style={{ maxWidth: "200px", maxHeight: "48px" }} onClick={gotToClientPortal}>
                            <Box
                                sx={{
                                    width: 200,
                                    height: 64,
                                    bgcolor: 'primary.lighter',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {logoimagesrc && logoimagesrc.length > 0 &&
                                    <img src={logoimagesrc} alt={logoimage ? logoimage.description : "logomarca"} style={{ maxWidth: "200px", maxHeight: "48px" }} onClick={gotToClientPortal} />
                                }
                            </Box>
                        </Grid>
                        {
                            title &&
                            <Grid item sm={1} justifyItems="center">
                                <Divider orientation='vertical' style={{ marginInline: "4px" }} />
                            </Grid>
                        }
                        {
                            title &&
                            <Grid item sm={5} alignContent="center" onClick={gotToClientPortal}>
                                <Typography variant='h5' color={defaulttextcolor ? defaulttextcolor : "primary"} >{title}</Typography>
                            </Grid>
                        }
                    </Grid>
                    <Grid container item sm={7} alignItems="center" justifyContent="end">
                        {
                            enablelogin &&
                            <Grid item sm={2} textAlign="center" alignContent="center">
                                <Typography
                                    variant='h5'
                                    style={{ cursor: "pointer" }}
                                    onClick={gotToLogin}
                                    color={defaulttextcolor ? defaulttextcolor : "primary"}
                                >
                                    {intl.formatMessage({ id: "enter" })}
                                </Typography>
                            </Grid>
                        }
                        {
                            enablelogin && showknowledgebases &&
                            <Grid item sm={1} justifyItems="center">
                                <Divider orientation='vertical' style={{ marginInline: "4px", height: 64 }} />
                            </Grid>
                        }
                        {
                            showknowledgebases &&
                            <Grid item sm={2} textAlign="center" alignContent="center">
                                <Typography
                                    variant='h5'
                                    style={{ cursor: "pointer" }}
                                    onClick={gotToKnowledgeBases}
                                    color={defaulttextcolor ? defaulttextcolor : "primary"}
                                >
                                    {intl.formatMessage({ id: "knowledgebases" })}
                                </Typography>
                            </Grid>
                        }

                        {
                            (enablelogin || showknowledgebases) && enablecreatecalled &&
                            <Grid item sm={1} justifyItems="center">
                                <Divider orientation='vertical' style={{ marginInline: "4px", height: 64 }} />
                            </Grid>
                        }
                        {
                            // Adiciona opção FAQ ao menu
                            enablefaq &&
                            <Grid item sm={2} textAlign="center" alignContent="center">
                                <Typography
                                    variant='h5'
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        let language = window.location.pathname.split('/')[1]
                                        if (language !== "pt" && language !== "es" && language !== "en")
                                            language = "pt"
                                        history.push(`/${language}/faq-external-client`)
                                    }}
                                    color={defaulttextcolor ? defaulttextcolor : "primary"}
                                >
                                    {intl.formatMessage({ id: "faq" })}
                                </Typography>
                            </Grid>
                        }
                        {enablefaq &&
                            <Grid item sm={1} justifyItems="center">
                                <Divider orientation='vertical' style={{ marginInline: "4px", height: 64 }} />
                            </Grid>
                        }

                        {
                            enablecreatecalled &&
                            <Grid item sm={3}>
                                {
                                    (defaultcolor && defaultcolor.length > 0) ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={_ => handleCreateCalled()}
                                            sx={{
                                                backgroundColor: defaultcolor,
                                                color: '#fff',
                                                textTransform: 'none',
                                                '&:hover': {
                                                    backgroundColor: darken(defaultcolor, 0.2),
                                                },
                                            }}
                                        >
                                            {intl.formatMessage({ id: "send.request" })}
                                        </Button>
                                        :
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={_ => handleCreateCalled()}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            {intl.formatMessage({ id: "send.request" })}
                                        </Button>
                                }
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Toolbar>
        </Grid>
    )
}

export default Header;